export const movementsExcelMapping = {
    // Spanish column name -> internal field name
    'Temporada': 'season',
    'Especie': 'species_id',
    'Monto USD': 'amount_usd',
    'Productor (debe coincidir con planilla de despachos)': 'producer_name',
    'Grupo Productor (debe coincidir con planilla de despachos)': 'producer_group',

  };
  
  export const requiredFields = [
    'season',
    'species_id',
    'amount_usd',
    'producer_name',
  ];
  
  export type MovementsRow = {
    [K in keyof typeof movementsExcelMapping]: string | number;
  };